import React from "react";
import PropTypes, { instanceOf } from "prop-types";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import TopAppBar from "../common_components/app_bar_options.component";
import BottomBar from "../common_components/bottom_bar_options.component";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Chip from "@material-ui/core/Chip";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Dropzone from "react-dropzone";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import axiosConfig from "../axiosConfig";
import axios from "axios";
import CancelIcon from "@material-ui/icons/Cancel";
import requireSub from "../common_components/requireAuthorized";
import MultipleImageUpload from "../common_components/multiple-image-upload";
import logo from "../../assets/img/cw_logo.png";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  rootbkg: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: 3,
    width: "90%",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  text_title: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "300",
    marginTop: "2%",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    textAlign: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#F6277F",
    width: 120,
    borderRadius: 0,
    borderColor: "#F6277F",
    border: "solid 1px",
    "&:hover": {
      //you want this to be the same as the backgroundColor above
      backgroundColor: "#d01b6a",
    },
  },
  cancel_btn: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FFF",
    width: 120,
    borderColor: "#F6277F",
    border: "solid 1px",
    borderRadius: 0,
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#000 !important",
  },
  labelColor: {},
  signin_text: {
    color: "grey",
    fontFamily: "Open Sans",
  },
  join_text: {
    color: "#F6277F",
    fontWeight: "600",
    fontFamily: "Open Sans",
    textTransform: "none",
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  cancel_text: {
    color: "#000",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  fieldset: {
    borderColor: "#F6227F",
    borderWidth: 1,
    borderRadius: 7,
    width: "70%",
    marginLeft: "15%",
    marginTop: "3%",
  },
  legend_text: {
    color: "black",
    fontFamily: "Open Sans",
    fontSize: 20,
    fontWeight: "700",
  },
  icon: {
    fill: "#F6277F",
  },
  splash_text: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "200",
    "@media (min-width:200px)": {
      fontSize: "1rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:960px)": {
      fontSize: "2rem",
    },
  },
  input: {
    minHeight: 300,
  },
  thc_text: {
    color: "black",
    fontFamily: "Open Sans",
    fontSize: 18,
    fontWeight: "300",
    marginRight: 18,
  },
  chip: {
    margin: theme.spacing(0.5),
    backgroundColor: "#CEF5F5",
    color: "#006E6E",
    fontFamily: "Open Sans",
    fontWeight: "600",
  },
  image_viewer: {
    display: "inline-block",
    width: "200px",
    height: "200px",
    overflow: "hidden",
    textAlign: "center",
    marginTop: "2%",
    borderColor: "#BCBCBC",
    border: "solid 2px",
    borderRadius: 4,
    marginRight: 10,
    marginLeft: 10,
  },
  drop_area: {
    margin: 30,
    padding: 30,
    width: "80%",
    transition: "all 0.5s",
  },
  form_control: {
    minWidth: "80%",
    marginTop: "3%",
    "@media (min-width:200px)": {
      minWidth: "30%",
    },
    "@media (min-width:600px)": {
      minWidth: "40%",
    },
    "@media (min-width:960px)": {
      minWidth: "70%",
    },
  },
  select: {
    border: "1px solid",
    "&:before": {
      borderColor: "red",
    },
    "&:after": {
      borderColor: "white",
    },
  },
  notched_outline: {
    borderWidth: "1px",
    borderColor: "#000 !important",
  },
});

let data = null;
class AddProduct extends React.Component {
  fileURL = [];
  fileArray = [];

  constructor(props) {
    super(props);
    this.state = {
      product_name: "",
      product_desc: "",
      product_form: "",
      product_type: "",
      usage_period: "",
      cannabinoid: "",
      cannabinoid_data: [],
      newCannabinoid: [],
      thc_value: "",
      cbd_value: "",
      cbg_value: "",
      images: [],
      terpene: [],
      plant_form_options: [],
      plant_type_options: [],
      usage_period_options: [],
      cannabinoid_options: [],
      cannabinoid_selected: [],
      form_type: [],
      terpene_options: [],
      loading: false,
      loadingImage: false,
      file: [],
      vertical: "bottom",
      horizontal: "center",
      open: false,
    };
    this.submitForm = this.submitForm.bind(this);

    this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this);

    this.handleDrop = this.handleDrop.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    document.title = "Add Product | CanaWho";
    let brand_id = sessionStorage.getItem("brand_id");
    // console.log("Im IN", brand_id);
    if (!brand_id) {
      // console.log("Im IN");
      this.props.history.push("/login");
    } else {
      // console.log("BRAND ID IS", brand_id);
      const productId = localStorage.getItem("productId");
      // console.log("Im IN", productId);
      if (productId) {
        axiosConfig
          .get(`/product/${brand_id}/${productId}`)
          .then((response) => {
            // console.log(response);
            data = response.data[0];
          })
          .catch((err) => {
            // console.log(err);
          });
      }
      axiosConfig
        .get("/configuration/")
        .then((config_response) => {
          this.setState({ loading: true });
          // console.log(config_response);
          this.loadData(config_response.data, data);
        })
        .catch((err) => {
          // console.log(err);
          // console.log(err.response);
          alert("Unexpected Error");
          // this.setState({loading: false})
        });
    }
  }

  loadData(configuration, product_data) {
    var plant_form = [],
      plant_type = [];

    configuration.map((data) => {
      data.form_type.map((data) => {
        plant_form.push(data.name);
      });
    });

    const array = configuration[0].form_type[0].type;
    array.map((data) => {
      plant_type.push(data.name);
    });

    this.setState({
      plant_form_options: plant_form,
      plant_type_options: plant_type,
      usage_period_options: configuration[0].usage_period,
      cannabinoid_options: configuration[0].cannabinoid,
      terpene_options: configuration[0].terpene,
      form_type: configuration[0].form_type,
      loading: false,
    });

    if (product_data) {
      this.setState({
        product_name: product_data.name,
        product_desc: product_data.description,
        product_form: product_data.form,
        product_type: product_data.type,
        usage_period: product_data.usage_period,
        cannabinoid_data: product_data.cannabinoid,
        terpene: product_data.terpene,
        images: product_data.image,
      });
    }
    this.setState({ loading: false });
  }

  submitForm() {
    const {
      product_name,
      product_desc,
      product_form,
      product_type,
      usage_period,
      cannabinoid_data,
      terpene,
      images,
      file,
    } = this.state;
    const productId = localStorage.getItem("productId");
    let brand_id = sessionStorage.getItem("brand_id");
    // console.log("IMAGE DATA:", file);
    // console.log("IMAGE DATA ARRAY:", this.fileArray);

    if (productId) {
      if (!product_name.trim() || !product_desc.trim()) {
        alert("Please fill in the required fields");
      } else {
        const obj = {
          _id: productId,
          name: product_name.trim(),
          description: product_desc.trim(),
          type: product_type.trim(),
          form: product_form.trim(),
          usage_period: usage_period.trim(),
          image: images,
          cannabinoid: cannabinoid_data,
          terpene: terpene,
        };
        axiosConfig
          .put(`/product/${brand_id}/${productId}`, obj)
          .then((res) => this.saveSuccess(res))
          .catch(function (error) {
            // console.log(error.response);
            alert(error);
          });
      }
    } else {
      if (!product_name.trim() || !product_desc.trim()) {
        alert("Please fill in the required fields");
      } else {
        const obj = {
          name: product_name.trim(),
          description: product_desc.trim(),
          type: product_type.trim(),
          form: product_form.trim(),
          usage_period: usage_period.trim(),
          image: images,
          cannabinoid: cannabinoid_data,
          terpene: terpene,
        };
        axiosConfig
          .post(`/product/${brand_id}`, obj)
          .then((res) => this.saveSuccess(res))
          .catch(function (error) {
            // console.log(error.response);
            alert(error);
          });
      }
    }
    localStorage.setItem("productId", "");
  }

  saveSuccess(response) {
    alert("Saved");
    window.history.back();
  }

  uploadMultipleFiles(e) {
    let that = this;
    const { target } = e;
    const { files } = target;
    if (files && files[0]) {
      const length_images = that.state.file.length + files.length;
      if (length_images <= 2) {
        for (var i = 0; i < files.length; i++) {
          e.preventDefault();

          let reader = new FileReader();
          let file = e.target.files[i];

          reader.onload = (event) => {
            that.fileArray.push(event.target.result);
            that.setState({ file: [...that.state.file, file] });
          };

          reader.readAsDataURL(file);
        }
      } else {
        alert("You can only upload 2 images at this time");
      }
    }
  }

  handleDrop = (files) => {
    // console.log(files.length);
    let that = this;
    if (!files) {
      return;
    }
    if (that.state.file.length < 2) {
      // console.log(that.state.file.length);
      // console.log(files.length);
      const length_images = that.state.file.length + files.length;
      if (length_images <= 2) {
        files.map((file) => {
          // console.log(file)
          // let reader = new FileReader();
          this.fileArray.push(URL.createObjectURL(file));
          // console.log(this.state.file)
          that.setState({ file: [...that.state.file, file] });
        });
      } else {
        alert("You can only upload 2 images at this time");
      }
    } else {
      alert("You can only upload 2 images at this time");
    }
  };

  addDefaultSrc(ev) {
    ev.target.src =
      "https://admin.cannawho.ca/static/media/logo-black-img-not-found.31ff94e5.png";
  }

  handleDelete = (chipToDelete) => () => {
    const { terpene } = this.state;

    if (chipToDelete > -1) {
      terpene.splice(chipToDelete, 1);
    }
    this.setState({ terpene: terpene });
  };

  removePhoto(index) {
    var array = [...this.state.images]; // make a separate copy of the array
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ images: array });
    }
  }

  addTerepene(value) {
    const { terpene } = this.state;
    if (value) {
      if (!terpene.includes(value)) {
        this.setState((prevState) => ({
          terpene: [...prevState.terpene, value],
        }));
      } else {
        this.setState({ open: true });
      }
    }
  }

  addCannabinoid(name) {
    const { cannabinoid_data } = this.state;
    if (name) {
      if (!cannabinoid_data.some((e) => e.name === name)) {
        this.setState({
          cannabinoid_data: [...cannabinoid_data, { name: name, value: "" }],
        });
      } else {
        this.setState({ open: true });
      }
    }
  }

  deleteCannabinoid(name) {
    const { cannabinoid_data } = this.state;
    if (name) {
      let new_list = cannabinoid_data.filter((e) => e.name !== name);
      this.setState({ cannabinoid_data: new_list });
    }
  }

  handleClose() {
    this.setState({ open: false });
  }

  setLinks = (action, link) => {
    // console.log("LINK", link);
    this.setState({ images: [...this.state.images, link] });
  };

  handleFormAndType(form) {
    let array = this.state.form_type;
    let plant_type = [];
    const result = array.filter((formType) => formType.name === form);
    result.map((data) => {
      data.type.map((data) => {
        plant_type.push(data.name);
      });
    });
    this.setState({ product_form: form, plant_type_options: plant_type });
  }

  render() {
    const { classes } = this.props;
    const {
      product_name,
      product_desc,
      product_form,
      plant_form_options,
      product_type,
      plant_type_options,
      usage_period,
      usage_period_options,
      cannabinoid,
      cannabinoid_options,
      cannabinoid_data,
      terpene,
      terpene_options,
      selected_terpene,
      loading,
      loadingImage,
      vertical,
      horizontal,
      open,
      images,
    } = this.state;
    // console.log("LINK", this.state.images.length);
    return (
      <div className={classes.root}>
        <TopAppBar />
        <Grid container direction="column" alignItems="center" justify="center">
          <div className={classes.paper}>
            <Grid container alignItems="center" justify="center">
              <h1 className={classes.text_title}>Add Product</h1>
            </Grid>
            {loading ? (
              <LinearProgress
                color="secondary"
                style={{ marginTop: "10%", marginBottom: "10%" }}
              />
            ) : (
              <form className={classes.form} autoComplete="off">
                <fieldset className={classes.fieldset}>
                  <legend className={classes.legend_text}>
                    Product Information
                  </legend>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={12}>
                      <TextField
                        style={{ width: "90%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        label="Name"
                        hintText="Name"
                        floatingLabelText="Name"
                        value={product_name}
                        onChange={(text) => {
                          this.setState({ product_name: text.target.value });
                        }}
                        autoFocus
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={12}>
                      <TextField
                        style={{ width: "90%" }}
                        variant="outlined"
                        margin="normal"
                        required
                        id="description"
                        label="Description"
                        multiline
                        type="text"
                        value={product_desc}
                        onChange={(text) => {
                          this.setState({ product_desc: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                          className: classes.input,
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item md={4}>
                      <FormControl
                        variant="outlined"
                        className={classes.form_control}
                      >
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          style={{ color: "#707070", background: "white" }}
                        >
                          Cannabis Form
                        </InputLabel>
                        <Select
                          labelId="simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={product_form}
                          onChange={(text) => {
                            this.handleFormAndType(text.target.value);
                            // this.setState({ product_form: text.target.value });
                          }}
                          className={classes.select}
                          inputProps={{ classes: { icon: classes.icon } }}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {plant_form_options.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={4}>
                      <FormControl
                        variant="outlined"
                        className={classes.form_control}
                      >
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          style={{ color: "#707070", background: "white" }}
                        >
                          Cannabis Type
                        </InputLabel>
                        <Select
                          labelId="simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={product_type}
                          onChange={(text) => {
                            this.setState({ product_type: text.target.value });
                          }}
                          className={classes.select}
                          inputProps={{ classes: { icon: classes.icon } }}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {plant_type_options.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item md={4}>
                      <FormControl
                        variant="outlined"
                        className={classes.form_control}
                      >
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          style={{ color: "#707070", background: "white" }}
                        >
                          Usage Period
                        </InputLabel>
                        <Select
                          labelId="simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={usage_period}
                          onChange={(text) => {
                            this.setState({ usage_period: text.target.value });
                          }}
                          className={classes.select}
                          inputProps={{ classes: { icon: classes.icon } }}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {usage_period_options.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </fieldset>
                <fieldset className={classes.fieldset}>
                  <legend className={classes.legend_text}>
                    Add Cannabinoid
                  </legend>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={4}>
                      <FormControl
                        variant="outlined"
                        className={classes.form_control}
                        style={{ width: "100%" }}
                      >
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          style={{ color: "#707070", background: "white" }}
                        >
                          Cannabinoid
                        </InputLabel>
                        <Select
                          labelId="simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={cannabinoid}
                          onChange={(text) => {
                            this.setState({ cannabinoid: text.target.value });
                          }}
                          className={classes.select}
                          inputProps={{ classes: { icon: classes.icon } }}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {cannabinoid_options.map((item) => (
                            <MenuItem value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        variant="contained"
                        style={{
                          backgroundColor: "#F6277F",
                          boxShadow: "2",
                          width: "50%",
                        }}
                        className={classes.submit}
                        onClick={() => this.addCannabinoid(cannabinoid)}
                      >
                        <Typography variant="h6" className={classes.enter_text}>
                          Add Cannabinoid
                        </Typography>
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" justify="space-evenly">
                    {cannabinoid_data
                      .sort((a, b) => {
                        return a.name > b.name ? 1 : -1;
                      })
                      .map((item, index) => (
                        <Grid
                          container
                          md={4}
                          direction="row"
                          justify="center"
                          alignItems="center"
                        >
                          <Typography variant="h6" className={classes.thc_text}>
                            {item.name}
                          </Typography>
                          <TextField
                            style={{ width: "40%" }}
                            variant="outlined"
                            margin="normal"
                            id="value"
                            label={`${item.name} Value`}
                            type="text"
                            autoComplete="section-number"
                            value={item.value}
                            onChange={(text) => {
                              let filtered = cannabinoid_data.filter(
                                (c) => c.name !== item.name
                              );
                              this.setState({
                                cannabinoid_data: [
                                  ...filtered,
                                  { name: item.name, value: text.target.value },
                                ],
                              });
                            }}
                            InputLabelProps={{ style: { color: "grey" } }}
                            InputProps={{
                              classes: {
                                notchedOutline: classes.notchedOutline,
                              },
                            }}
                          />
                          <IconButton
                            style={{ color: "#F6227F", marginLeft: 16 }}
                            aria-label="delete"
                            onClick={() => this.deleteCannabinoid(item.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      ))}
                  </Grid>
                </fieldset>
                <fieldset className={classes.fieldset}>
                  <legend className={classes.legend_text}>Add Terpene</legend>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={4}>
                      <FormControl
                        variant="outlined"
                        className={classes.form_control}
                        style={{ width: "100%" }}
                      >
                        <InputLabel
                          id="demo-simple-select-outlined-label"
                          style={{ color: "#707070", background: "white" }}
                        >
                          Terpene
                        </InputLabel>
                        <Select
                          labelId="simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          value={selected_terpene}
                          onChange={(text) => {
                            this.setState({
                              selected_terpene: text.target.value,
                            });
                          }}
                          className={classes.select}
                          inputProps={{ classes: { icon: classes.icon } }}
                        >
                          <MenuItem value={""}>
                            <em>None</em>
                          </MenuItem>
                          {terpene_options.map((item, index) => (
                            <MenuItem value={item} key={index}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        variant="contained"
                        style={{
                          backgroundColor: "#F6277F",
                          boxShadow: "2",
                          width: "50%",
                        }}
                        className={classes.submit}
                        onClick={() => this.addTerepene(selected_terpene)}
                      >
                        <Typography variant="h6" className={classes.enter_text}>
                          Add Terpene
                        </Typography>
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" justify="space-evenly">
                    <Grid item xs={12}>
                      {terpene.map((data, index) => (
                        <Chip
                          key={data}
                          label={data}
                          onDelete={this.handleDelete(index)}
                          className={classes.chip}
                        />
                      ))}
                    </Grid>
                  </Grid>
                </fieldset>

                {images
                  ? images.map((url, index) => (
                      <Grid className={classes.image_viewer}>
                        <IconButton
                          component="label"
                          style={{
                            color: "#F6227F",
                            marginBottom: -20,
                            marginLeft: 150,
                          }}
                          aria-label="delete"
                          onClick={() => this.removePhoto(index)}
                        >
                          <CancelIcon style={{ fontSize: "24px" }} />
                        </IconButton>
                        {loadingImage ? (
                          <CircularProgress />
                        ) : (
                          <img
                            alt="..."
                            onError={this.addDefaultSrc}
                            src={url}
                            style={{
                              height: "200px",
                              width: "200px",
                              marginTop: -27,
                            }}
                          />
                        )}
                      </Grid>
                    ))
                  : null}
                {images && images.length > 1 ? null : (
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="center"
                    alignItems="center"
                    style={{ minWidth: "80%" }}
                  >
                    <Grid
                      item
                      xs={8}
                      justify="center"
                      align="center"
                      style={{
                        border: "dashed 2px #979A9B",
                        borderRadius: 8,
                        marginTop: 18,
                        minHeight: "20vh",
                      }}
                    >
                      <Grid item xs={10} style={{ marginTop: 20 }}>
                        <MultipleImageUpload
                          maxFiles={2 - (images.length ? images.length + 1 : 0)}
                          updateLinks={this.setLinks.bind(this)}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                <Grid container direction="row" justify="center">
                  <Grid item md={2}>
                    <Button
                      // type="submit"
                      fullWidth
                      variant="contained"
                      className={classes.submit}
                      onClick={this.submitForm}
                    >
                      <Typography variant="h6" className={classes.enter_text}>
                        Save
                      </Typography>
                    </Button>
                  </Grid>
                  <Grid item md={2}>
                    <Button
                      // type="submit"
                      fullWidth
                      variant="contained"
                      className={classes.cancel_btn}
                      onClick={() => {
                        localStorage.setItem("productId", "");
                        window.history.back();
                      }}
                    >
                      <Typography variant="h6" className={classes.cancel_text}>
                        Cancel
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
            <Grid>
              <img
                alt=""
                style={{ padding: 10, marginTop: 16, height: 80 }}
                src={logo}
              />
            </Grid>
          </div>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={`${vertical},${horizontal}`}
            open={open}
            onClose={this.handleClose}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={<span id="message-id">Already Exists</span>}
          />
        </Grid>
        <BottomBar />
      </div>
    );
  }
}

AddProduct.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default requireSub(withStyles(styles)(AddProduct));
